import { createElement } from 'react';
import { NewTypography as Typography, spacing } from '@lamimed/pantheon';
import { LucideIcon } from 'lucide-react';

import * as S from './styles';

export interface Crumb {
  href: string;
  content: string;
  icon: LucideIcon;
}

interface Props {
  crumbs: Array<Crumb>;
  marginBottom?: keyof typeof spacing;
}

export function Breadcrumb({ crumbs, marginBottom = 'none' }: Props) {
  return (
    <S.Container marginBottom={marginBottom}>
      {crumbs.map(({ icon, href, content }, i) => (
        <S.Crumb key={i} href={href}>
          {createElement(icon, { size: 14 })}

          <Typography
            variant="body_text_3"
            lineHeight="none"
            marginTop="none"
            marginBottom="none"
          >
            {content}
          </Typography>
        </S.Crumb>
      ))}
    </S.Container>
  );
}
